<div class="modal-header">
  <h2 class="modal-title" id="modal-title">{{titletxt}} Signature(s)</h2>
  <span type="button" class="btn-close" (click)="modal.dismiss('')"></span>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col col-md-12">
    </div>
  </div>
  <div class="row">
    <div class="col col-md-12">
      <kendo-grid [data]="eSignatureList.Signatures">
        <kendo-grid-column field="FullName" title="User" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>            
            <div [innerHTML]="dataItem.FullName"></div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Action" title="Action" [width]="100">
        </kendo-grid-column>
        <kendo-grid-column field="DateSigned" title="Date Signed" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.DateSigned | date: 'dd-MMM-yyyy'}}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>


